/**
 * HTTP constants
 */
export const HTTP_HEADER_KEY_CONTENT_TYPE = 'Content-Type';
export const HTTP_HEADER_VALUE_APPLICATION_JSON = 'application/json';
export const HTTP_RESPONSE_RETURN_CODE_OK = 1;
export const HTTP_RESPONSE_RETURN_CODE_KO = 2;
export const HTTP_STATUS_CODE_UNAUTHORIZED = 401;
export const HTTP_STATUS_CODE_NOT_FOUND = 404;
export const HTTP_STATUS_CODE_CONFLICT = 409;
export const HTTP_STATUS_CODE_BAD_REQUEST = 400;
export const PUBLIC_SUFFIX = 'public/';

/**
 * Safety recommendations statuses
 */
export const PUBLISHED = 'PUBLISHED';

/**
 * Module routes
 */
export const SAFETY_RECOMMENDATIONS_ROUTE = 'safety-recommendations';
export const SAFETY_RECOMMENDATIONS_DETAILS_ROUTE = 'detail';
export const SAFETY_RECOMMENDATIONS_SEARCH_ROUTE = 'search';
export const NOT_FOUND_ROUTE = 'not-found';
export const UNDER_MAINTENANCE = 'under-maintenance';

export const ECCAIRS = 'ECCAIRS';
